import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useOrganization } from '@/hooks/useOrganizations';
import { useDialog } from '@/providers/DialogProvider';
import { Trash } from '@mynaui/icons-react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { DeleteOrganizationDialog } from './DeleteOrganizationDialog';

export const OrganizationDangerZone: FunctionComponent = () => {
  const { t } = useTranslation('orgSettings');
  const { openDialog } = useDialog();
  const organization = useOrganization();

  if (!organization) return null;

  return (
    <Card className='border-rose-200'>
      <CardHeader className='border-rose-200 bg-rose-50/40'>
        <CardTitle className='text-rose-600'>{t('danger.title')}</CardTitle>
        <CardDescription className='text-rose-600/70'>{t('danger.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className='flex items-center justify-between overflow-hidden'>
          <div className='flex flex-col gap-1'>
            <h3 className='font-medium leading-none text-slate-900 dark:text-white'>{t('danger.deleteOrganization')}</h3>
            <p className='text-sm font-medium leading-none text-slate-500 dark:text-white/70 whitespace-normal'>
              {t('danger.deleteDescription')}
            </p>
          </div>
          <AlertDialog>
            <AlertDialogTrigger asChild>
              <Button variant='destructive'>
                <Trash className='h-4 w-4 mr-2 stroke-2' />
                {t('danger.deleteOrganization')}
              </Button>
            </AlertDialogTrigger>
            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle>{t('danger.confirmTitle')}</AlertDialogTitle>
                <AlertDialogDescription>
                  {t('danger.confirmDescription', { name: organization.name }).replace(/<\/?bold>/g, '')}
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel>{t('danger.cancel')}</AlertDialogCancel>
                <AlertDialogAction
                  onClick={() =>
                    openDialog(
                      <DeleteOrganizationDialog
                        organizationId={organization.id}
                        organizationName={organization.name}
                      />,
                    )
                  }
                  variant='destructive'>
                  {t('danger.deleteOrganization')}
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        </div>
      </CardContent>
    </Card>
  );
};
